module.exports = __webpack_public_path__ + "static/media/7.cad9a545.jpg";